import { AlertTriangle, ClipboardCheck, LayoutDashboard, Settings } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

type NavItem = {
  name: string;
  href: string;
  icon: typeof LayoutDashboard;
};

const navigation: NavItem[] = [
  { name: "ダッシュボード", href: "/admin", icon: LayoutDashboard },
  { name: "スキルチェック", href: "/admin/skill-checks", icon: ClipboardCheck },
  { name: "エラー分析", href: "/admin/errors", icon: AlertTriangle },
  { name: "設定", href: "/admin/settings", icon: Settings },
];

export function Sidebar() {
  const location = useLocation();

  const isActive = (href: string) => {
    if (href === "/admin") {
      return location.pathname === "/admin";
    }
    return location.pathname.startsWith(href);
  };

  return (
    <aside className="fixed inset-y-0 left-0 w-64 bg-gray-900">
      <div className="flex h-16 items-center justify-center border-gray-800 border-b">
        <h1 className="font-bold text-white text-xl">スキルチェック管理</h1>
      </div>
      <nav className="mt-6 px-3">
        <ul className="space-y-1">
          {navigation.map((item) => {
            const active = isActive(item.href);
            return (
              <li key={item.name}>
                <Link
                  className={`flex items-center gap-3 rounded-md px-3 py-2 font-medium text-sm transition-colors duration-200 ${
                    active
                      ? "bg-gray-800 text-white"
                      : "text-gray-400 hover:bg-gray-800 hover:text-white"
                  }
                  `}
                  to={item.href}
                >
                  <item.icon className="h-5 w-5" />
                  {item.name}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
}
